import {
    Row,
    CardHeader
} from "reactstrap";

const LocationModalTreeHeader = () => {
    return (
        <CardHeader>
            <Row className="ml-2">
                <h3 className="align-middle">Hierarchy Assignment</h3>
            </Row>
        </CardHeader>
    )
}

export default LocationModalTreeHeader;